import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import _ from 'lodash';

import DepartmentPage from '../components/company/department-page';

const DepartmentRoute = ({ department, blogs, match }) => {
  const slug = _.get(match, 'params.slug', '');
  if ((slug !== '' && slug.split(' ').length > 1) || /[A-Z]/.test(slug)) {
    const newSlug = _.kebabCase(slug);
    return <Redirect to={`/careers/${newSlug}`} />;
  }

  return (
    <Fragment>
      <DocumentTitle title={`${_.get(department, 'name', '')} | NerdWallet`} />
      <DepartmentPage
        department={department}
        blogPosts={_.get(
          blogs,
          [_.get(department, 'slug', ''), 'blogPosts'],
          []
        )}
      />
    </Fragment>
  );
};

DepartmentRoute.displayName = 'Department Route';
DepartmentRoute.analyticsName = 'department_page';

DepartmentRoute.propTypes = {
  department: PropTypes.object.isRequired,
  blogs: PropTypes.object,
  match: PropTypes.object,
};

export default connect((state) => ({
  department: state.careersData.department,
  blogs: state.careersData.blogs,
}))(DepartmentRoute);
